import React from "react";
import { CellProps } from "react-table";
import Button from "shared/components/button";
import { useAuth } from "shared/context/auth";
import useAssignmentCellService from "./service";
import { Copies, useCopies } from "shared/hooks/useCopies";
import { ParticipantRole } from "shared/enums/ParticipantRole";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";
import AlertModal from "shared/components/alertModal";
import NonAttendeeApplicationStatus from "../../../../../../../shared/enums/NonAttendeeApplicationStatus";
import { AdminConsoleLoginResponse } from "shared/context/auth/type";

export function getAssignmentCellValue(
  copies: Copies,
  participantData: ApiRegistrationParticipantForManagement,
  userDetail?: AdminConsoleLoginResponse,
  revokeOrgAdminHandler?: (participantData: ApiRegistrationParticipantForManagement) => void,
  nominateOrgAdminHandler?: (id: string) => void
) {
  // Revoke: Logged in user is not same as participant, is not org admin and given participant is org admin
  if (
    userDetail?.id !== participantData.id &&
    userDetail?.participantRoles.includes(ParticipantRole.ORGANIZATION_ADMIN) &&
    participantData.participantRoles.includes(ParticipantRole?.ORGANIZATION_ADMIN)
  ) {
    return {
      value: copies.get("revoke"),
      clickHandler: () => revokeOrgAdminHandler?.(participantData)
    };
  }

  // Assign: when participant is not org admin
  if (
    !participantData.participantRoles.includes(ParticipantRole?.ORGANIZATION_ADMIN) &&
    participantData.nonAttendeeApplication?.status !==
      NonAttendeeApplicationStatus.ORG_ADMIN_APPLICATION_APPROVAL_PENDING
  ) {
    return {
      value: copies.get("assign"),
      clickHandler: () => nominateOrgAdminHandler?.(participantData.id)
    };
  }

  return {
    value: copies.get("empty.cell")
  };
}

export default function AssignmentCell(props: CellProps<ApiRegistrationParticipantForManagement>) {
  const copies = useCopies();
  const service = useAssignmentCellService();
  const { userDetail } = useAuth();

  const cellValue = React.useMemo(
    () =>
      getAssignmentCellValue(
        copies,
        props.row.original,
        userDetail,
        service.revokeOrgAdminHandler,
        service.nominateOrgAdminHandler
      ),
    [copies, props.row.original, service.nominateOrgAdminHandler, service.revokeOrgAdminHandler, userDetail]
  );
  return (
    <div className="manageOrgAdmin_tableActions">
      {cellValue.clickHandler ? (
        <Button.Link label={cellValue.value} onClick={cellValue.clickHandler} />
      ) : (
        <span>{cellValue.value}</span>
      )}
      {service.alertConfig && <AlertModal {...service.alertConfig} />}
    </div>
  );
}
